import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {cancelRefundMetaOrder} from "../../actions/SalesApiActions";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmWithReasonForm";
import {Map, fromJS} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values, _props) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

// From Facebook API
// https://developers.facebook.com/docs/commerce-platform/order-management/cancellation-refund-api#refund_reason_code
const META_REFUND_REASONS = fromJS([
  { id: "BUYERS_REMORSE", title: "Refunded by buyers remorse." },
  { id: "DAMAGED_GOODS", title: "Refunded as goods were delivered damaged." },
  { id: "FACEBOOK_INITIATED", title: "Refund issued by the Facebook support team, usually in response of a dispute with the buyer." },
  { id: "NOT_AS_DESCRIBED", title: "Product not as described." },
  { id: "QUALITY_ISSUE", title: "Product had quality issues." },
  { id: "REFUND_REASON_OTHER", title: "Other refund reason." },
  { id: "WRONG_ITEM", title: "Wrong product delivered." },
]);

class MetaOrderRefundFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("metaOrderId", this.props.metaOrderId)
    return this.props.cancelMetaOrder(updatedValues.toJS())
      .then((response) => {
        if (response.data.cancelMetaOrder.errors.length <= 0) {
          this.handleCancel();
        } else {
          let errors = createValidationErrors(response.data.cancelMetaOrder.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRefundMetaOrder();
  }

  render() {
    return (
      <Form
        options={META_REFUND_REASONS}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}>
        <p>Refunds cannot work on completed orders.</p>
      </Form>
    )
  }
}


const REFUND_META_ORDER = gql`
  mutation refundMetaOrder($data: RefundMetaOrderInput!) {
    refundMetaOrder(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(REFUND_META_ORDER, {
    props: ({ mutate }) => ({
      cancelMetaOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelRefundMetaOrder})(withMutation(MetaOrderRefundFormContainer));
